import controller from './verify-email.controller';
import template from './verify-email.pug';

const VerifyEmailComponent = {
  template,
  controller,
};

export default VerifyEmailComponent;



// WEBPACK FOOTER //
// ./client/app/oauth/verify-email/verify-email.component.js